import { media, InfoOutlineIcon } from 'ia-react-core';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  padding-top: 24px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 25px;
  border-bottom: 1px solid ${({ theme }) => theme?.colors.gray3};
  ${media.sm`
  padding-left: 32px;
  padding-right: 32px;
  `};
`;

export const StyledMessage = styled.aside`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  ${media.sm`
    flex-direction: row;
    align-items: left;
    text-align: left;
  `};
`;

export const StyledIcon = styled(InfoOutlineIcon)`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  color: #3f92a6;
`;

export const StyledFormMessageText = styled.span`
  margin-top: 12px;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  ${media.sm`
    margin-left: 12px;
    margin-top: 0px;
  `};
`;
